import axios from 'axios'
const Tools = {
    getFundInfo(code) {
        //获取基金信息
        return new Promise((resolve, reject) => {
            axios.get('api/Fund/GetOne?code=' + code + '&rt=' + Date.now())
                .then(res => {
                    console.log('handlerAddZX res', res)
                    var tmp = res.data.substr(8)
                    var result = tmp.substr(0, tmp.length - 2)
                    console.log('result:', result);
                    if (result.length > 0) {
                        var fundObj = JSON.parse(result)
                        resolve(fundObj);
                    } else {
                        reject({
                            message: '找不到该基金的估值信息',
                            type: 'warning',
                        })
                    }
                })
        })
    },
    getFundList() {
        //获取基金列表
        return new Promise((resolve, reject) => {
            axios.get('api/Fund/GetAll').then(res => {
                // console.log('data', res.data)   
                var tmp = res.data.substr(8)
                var result = tmp.substr(0, tmp.length - 1)
                var allFundList = JSON.parse(result).filter(i => (i[2].indexOf('(后端)') == -1) && (i[3] != '货币型'))
                localStorage.setItem('allFundList', JSON.stringify(allFundList))
                resolve(allFundList)
            })
        });
    }
}
export default Tools